import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  // We use Bearer tokens in localStorage, not cookies, so keep withCredentials
  // off. This lets the backend CORS policy allow the browser origin cleanly.
  withCredentials: false,
});

export function authHeader() {
  const t = localStorage.getItem("rrdc_admin_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
}

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("rrdc_admin_token");
  if (t && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  const gate = localStorage.getItem("rrdc_parent_gate");
  if (gate && !config.headers["x-parent-gate"]) {
    config.headers["x-parent-gate"] = gate;
  }
  return config;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  return typeof d === "object" ? (d.msg || JSON.stringify(d)) : String(d);
}
